import React from 'react';
import { format } from 'date-fns';
import { actionsColumn } from '@onward-delivery/design';

const Muted = ({ children }) => <span className="text-muted">{children}</span>;

const clientColumn = (id, header) => ({
    id,
    header,
    size: 160,
    accessorFn: (row) => row[`${id}_name`],
    cell: ({ getValue }) => getValue() || <Muted>-</Muted>,
    meta: { filter: { type: 'multi-select' } },
});

export const automationColumns = ({ onEdit, onDelete }) => [
    {
        accessorKey: 'url',
        header: 'Endpoint',
        size: 270,
        cell: ({ getValue }) => (
            <span className="!font-mono text-sm" title={getValue()}>
                {getValue()}
            </span>
        ),
        meta: { filter: { type: 'multi-select' } },
    },
    clientColumn('shipper_id', 'Shipper'),
    clientColumn('carrier_id', 'Carrier'),
    clientColumn('middle_mile_carrier_id', 'Middle Mile Carrier'),
    {
        id: 'schedule',
        header: 'Schedule',
        size: 180,
        accessorFn: (row) => `${row.crontab} ${row.timezone}`,
        cell: ({ row }) => (
            <div className="flex flex-col">
                <span className="!font-mono text-sm">{row.original.crontab}</span>
                <span className="text-xs text-muted">{row.original.timezone}</span>
            </div>
        ),
    },
    {
        id: 'key',
        header: 'Job',
        size: 120,
        accessorFn: (row) => (row.key ? 'Synced' : 'Pending'),
        cell: ({ row }) =>
            row.original.key ? (
                <span title={row.original.key}>Synced</span>
            ) : (
                <span className="text-warning" title="The scheduler job is created a few seconds after saving">
                    Pending
                </span>
            ),
        meta: { filter: { type: 'select' } },
    },
    {
        accessorKey: 'last_modified_at',
        header: 'Last Modified',
        size: 150,
        cell: ({ getValue }) => (getValue() ? format(new Date(getValue()), 'MMM d, yyyy') : <Muted>-</Muted>),
    },
    actionsColumn(() => [
        { label: 'Edit', onSelect: onEdit },
        { label: 'Delete', onSelect: onDelete },
    ]),
];
